<template>
<div class="chapter">
<div class="inner_page">
<p class="copyrightaa"><a id="page_iv"></a>Cataloging-in-Publication Data has been applied for and<br/>may be obtained from the Library of Congress.<br/>ISBN 978-0-8109-8921-4</p>
<p class="copyrighta">Copyright © 2010 William Buckholz</p>
<p class="copyrighta">Published in 2010 by Abrams Image, an imprint of ABRAMS. All rights reserved.<br/>No portion of this book may be reproduced, stored in a retrieval system, or transmitted<br/>in any form or by any means, mechanical, electronic, photocopying, recording,<br/>or otherwise, without written permission from the publisher.</p>
<p class="copyrighta">Printed and bound in U.S.A.<br/>10 9 8 7 6 5 4 3 2 1</p>
<p class="copyrighta">Abrams Image books are available at special discounts when purchased in quantity<br/>for premiums and promotions as well as fundraising or educational use.<br/>Special editions can also be created to specification.</p>
<p class="copyright">For details, contact specialmarkets@abramsbooks.com, or the address below.</p>
<p class="copyrightaa"><img alt="Image" src="images/pub1.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?09a62ce1